import React from "react";
import UserFooter from "../../components/common/UserFooter";
import UserNavbar from "../../components/common/UserNavbar";
import { useLocation } from "react-router-dom";
import ChatBot from "../../components/common/ChatBot";

const UserLayout = (props) => {
  const location = useLocation();
  const hideFooterRoutes = ["/service-cart", "/user-profile", "/my-bookings"];
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <ChatBot />
      {!shouldHideFooter && <UserFooter />}
    </React.Fragment>
  );
};

export default UserLayout;
